export { default as WidgetReviewsPage } from './WidgetReviewsPage';
